module.exports = __webpack_public_path__ + "static/media/check-mark.e298c46c.svg";